import countries from '@/assets/json/countries.json';

function getCountriesList() {
  return countries;
}

export default () => ({ getCountriesList });
